import { render, staticRenderFns } from "./advertisingSDKTypeManagement.vue?vue&type=template&id=0cea4e96&scoped=true&"
import script from "./advertisingSDKTypeManagement.vue?vue&type=script&lang=js&"
export * from "./advertisingSDKTypeManagement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cea4e96",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\sdk_manage_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0cea4e96')) {
      api.createRecord('0cea4e96', component.options)
    } else {
      api.reload('0cea4e96', component.options)
    }
    module.hot.accept("./advertisingSDKTypeManagement.vue?vue&type=template&id=0cea4e96&scoped=true&", function () {
      api.rerender('0cea4e96', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/packagingManagement/advertisingSDKTypeManagement.vue"
export default component.exports